    <template>
    <div id="adminlogin">
        <div class="container-fluid">
            <Alert v-bind:message='error'   type="alert-danger" v-if="error"/>
            <div class="row">
                    <div class="col-12 text-center my-4 ">
                        <img height="50" src="../assets/tribeid.png" alt="">
                    </div>
                </div>

            <div class="row justify-content-center align-items-">
                
                <div class="col-lg-10 col-md-11 col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h2 class="text-center">Register your Organization</h2>
                            <p class="text-center">Fill in the form below to register your organization</p>
                        </div>
                        <div class="card-body">
                            <form class="" @submit.prevent="login">
                                <div class="form-row">
                                    <div class="form-group mb-2 col-md-6">
                                        <label for="organization" class="form-label">Organization Name:</label>
                                        <input type="text" class="form-control" id="organization"
                                        required placeholder="Name of Agency or Oganization" v-model.trim="name">
                                    </div>
                                    <div class="form-group mb-2 col-md-6">
                                        <label for="market" class="form-label">Market:</label>
                                        <input type="text" class="form-control" id="market" 
                                            required placeholder="Market Name" v-model.trim="market">
                                    </div>
                                    <div class="form-group mb-2 col-md-6">
                                        <label for="email" class="form-label">Email</label>
                                        <input type="email" class="form-control" id="email" 
                                            required placeholder="me@example.com" v-model.trim="email">
                                    </div>
                                    <div class="form-group mb-2 col-md-6">
                                        <label for="password" class="form-label">Password:</label>
                                        <input type="password" class="form-control" id="password" 
                                            required placeholder="Password" v-model.trim="password">
                                    </div>
                                    <div class="form-group mb-2 col-md-6">
                                        <label for="exampleFormControlSelect1">Select Type:</label>
                                        <select class="form-control" id="exampleFormControlSelect1" v-model.trim="type">
                                            <option >Organization</option>
                                            <option >Outlet</option>
                                            <option >Agency</option>
                                        </select>
                                    </div>
                                    <div class="form-group mb-2 col-md-6">
                                        <label for="staticEmail2" class="form-label">Phone Number:</label> 
                                        <vue-tel-input v-model="phone"></vue-tel-input>
                                    </div> 
                                    <div class="col-md-6 py-3">
                                        <p class="px-4">By continuing, your organization agree's to our <a href="">Terms</a> and <a href="">Privacy Policy</a></p>
                                    </div> 
                                    <div class="col-md-6 py-3">
                                        <button type="submit" class="btn btn-danger my-2 btn-lg">
                                            Register Organization
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <div class="row my-2">
                                <div class="col-12">
                                    <hr>
                                     <p class="text-center">Already have an account? <a href="/accounts/signin/">Sign In</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alert from '../components/Alert'
import { VueTelInput } from 'vue-tel-input'
export default {
    components: {
        Alert:Alert,
        VueTelInput:VueTelInput
    },
    data(){
        return {
            email:'',
            password:'',
            error:'',
            loading:false,
        }
    },
    methods: {
        login() {
            this.loading = true
            this.error = ''
            const data = {
                email:this.email,
                password:this.password
            }
            this.$store.dispatch('adminLogin',data)
                .then( (data) => {  
                    this.loading = false
                    this.$router.push('/admin')  
                    })
                .catch( (err) => {
                    if(err?.response?.data === undefined) {
                        this.loading = false;
                        this.error = 'Network error!.Try again.'
                    }
                })
           }

    },

}
</script>

<style scoped>
    #adminlogin{
        background-image:url('../assets/hero.jpg');
        width:100%;
        background-position: center;
        background-attachment: fixed;
        background-repeat: no-repeat;
        height: 100vh;
    }
    h2{
        color:black;
        font-weight: 500;
        font-size: 1.8em;
    }
    a{
        color:red;
    }
    button{
        width:100%;
    }
    :placeholder-shown,label,button,a,p{
        font-size: .96em;
    }   
    a:hover{
        color:black;
    }
</style>    